var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.props.tooltip),expression:"props.tooltip"}],staticClass:"LmActorCircle",class:[_vm.data.class, _vm.data.staticClass, 'text-' + _vm.props.color]})}
var staticRenderFns = []

export { render, staticRenderFns }